// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1pDJp","title":"FrontImage_title__3rPFz"};